"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.DefaultApiRequestsContext = {
    sendImpactAnalysisEmailAndShowToast: function (_) { return Promise.resolve(); },
    setColumnDescription: function (_) { return Promise.resolve(); },
    canUserSetColumnDescription: function (_) { return Promise.resolve(false); },
    canUserSendImpactAnalysisEmail: function (_) { return Promise.resolve(false); },
};
exports.ApiRequestsContext = React.createContext(exports.DefaultApiRequestsContext);
function consumeApiRequestsContext(wrappedComponent) {
    return function ApiRequestsContextConsumerHOC(props) {
        return (React.createElement(exports.ApiRequestsContext.Consumer, null, function (apiRequests) { return React.createElement(wrappedComponent, __assign({ apiRequests: apiRequests }, props)); }));
    };
}
exports.consumeApiRequestsContext = consumeApiRequestsContext;
//# sourceMappingURL=ApiRequestsContext.js.map